import { trackApi } from '@ardoq/api';
import { isAutomatedTestMode, isDevelopmentMode, isOnPremise } from '../env';

export const track: TrackFn = (name, metadata) => {
  // eslint-disable-next-line no-console
  if (isDevelopmentMode()) console.info(`Tracking ${name}`, metadata);
  if (isOnPremise()) return;
  if (isAutomatedTestMode()) return;

  trackApi.trackEvent({
    name,
    metadata,
    context: {
      userAgent: navigator.userAgent,
      page: {
        path: window.location.pathname,
        referrer: document.referrer,
      },
    },
    client: 'ardoq-front',
  });
};

// Anonymous viewers (e.g. public presentations) have no session, so they can
// only reach the unauthenticated tracking endpoint — which is scoped to the
// login flow (client "ardoq-login" + a fixed event allowlist) and rejects
// ardoq-front events. Use this no-op for those surfaces instead of emitting
// requests the backend will 400.
export const noTracking: TrackFn = () => {};

export type TrackFn = (
  name: string,
  metadata?: Record<string, unknown>
) => void;
